import React from "react";
import loading from "../../../assests/uploadLoading2.gif";

const UploadLoading = () => {
  return (
    <div className="">
      <img src={loading} alt="loading" />
    </div>
  );
};

export default UploadLoading;
